module.exports = __webpack_public_path__ + "static/img/clean.71edc064.png";